import { scrollToHomeRecentUpdatesCommentPost } from './homeRecentUpdatesTourApi';
import {
  getRecentUpdatesVisibleClip,
  isRectComfortablyInView,
  isRectPartiallyInView,
  revealRecentUpdatesTourTarget,
} from './homeTourScroll';

const FEED_SCROLLER_SELECTOR = '[data-tour="home-recent-updates-scroller"]';
const WIDGET_SELECTOR = '#home-recent-updates-widget';
const COMMENTS_SELECTOR = '[data-tour="home-recent-updates-card-comments"]';

const getFeedScroller = (widget: Element): HTMLElement | null => {
  const scroller = widget.querySelector(FEED_SCROLLER_SELECTOR);
  return scroller instanceof HTMLElement ? scroller : null;
};

/**
 * Picks a reaction/comment tour target inside Recent Updates.
 *
 * Prefer an icon the user can already see (so the first card is not yanked
 * away). If comments live on a Common room card that Virtuoso has not mounted,
 * reveal it first, then return the CTA so the scroll strategy can ease to it.
 */
export const resolveHomeRecentUpdatesTourElement = (
  selector: string,
  root: ParentNode = document
): Element | null => {
  const widget = root.querySelector(WIDGET_SELECTOR);
  if (!widget) {
    return null;
  }

  let candidates = Array.from(widget.querySelectorAll(selector));
  if (candidates.length === 0 && selector === COMMENTS_SELECTOR) {
    scrollToHomeRecentUpdatesCommentPost({ smooth: false });
    revealRecentUpdatesTourTarget(widget, selector);
    candidates = Array.from(widget.querySelectorAll(selector));
  }
  if (candidates.length === 0) {
    return null;
  }

  const scroller = getFeedScroller(widget);
  const viewEl = scroller ?? (widget instanceof HTMLElement ? widget : null);
  if (!viewEl) {
    return candidates[0];
  }

  const viewRect = getRecentUpdatesVisibleClip(viewEl);

  return (
    candidates.find((el) =>
      isRectComfortablyInView(el.getBoundingClientRect(), viewRect)
    ) ??
    candidates.find((el) =>
      isRectPartiallyInView(el.getBoundingClientRect(), viewRect)
    ) ??
    candidates[0]
  );
};
